document.addEventListener('DOMContentLoaded', () => {
	// slick default setting
	let defaulsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	}

	// start slider default
	let allSwipper = []

	document.querySelectorAll('.swiper-slider').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper? JSON.parse(element.dataset.swiper): defaulsettings
		element.setAttribute(`data-swiper-${i}`, '')
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig)
		allSwipper[i] = swiper
	})

	//Custom Controls
	allSwipper.forEach((swiper) => {
		const {customcontrol} = swiper.passedParams

		if (customcontrol) {
			const targetSelectors = customcontrol.split(',').map((s) => s.trim()).filter(Boolean)
			const targetSwipers = allSwipper.filter((s) =>
				targetSelectors.some((selector) =>
					selector.startsWith('#')? s.el.id === selector.slice(1): selector.startsWith('.')? s.el.classList.contains(selector.slice(1)): false,
				),
			)

			if (targetSwipers.length) {
				swiper.controller.control = targetSwipers
			}
		}
	})

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto): 0
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider')
		item.addEventListener('click', (e) => {
			slider.swiper.slideTo(target)
			document.querySelectorAll(`[data-swiper-goto]`).forEach((itm) => itm.classList.remove('active'))
			item.classList.add('active')
		})
	})

	let swipperTwoImages = new Swiper('.slider-two-images .slider-two-images__slider', {
		slidesPerView: 1,
		loop: true,
		spaceBetween: 0,
		pagination: {
			el: '.slider-two-images__slider .swiper-pagination',
			type: 'fraction',
        },
        navigation: {
			nextEl: '.slider-two-images__slider .swiper-button-next',
			prevEl: '.slider-two-images__slider .swiper-button-prev',
        },
		breakpoints: {
			768: {
				slidesPerView: 1.8,
				spaceBetween: 60
			},
        },
	})
})
